exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sole_2P5tRZjo {\n  background: #fff;\n  margin-top: 0.133333rem;\n}\n\n.soleMd_1wKGmTCR {\n  text-align: center;\n  padding: 0.533333rem 0 0.4rem;\n}\n\n.soleMdImg_QbBIMpmi {\n  width: 3.386667rem;\n}\n\n.viewMore_32xGFsh1 {\n  height: 1.066667rem;\n  line-height: 1.066667rem;\n  text-align: center;\n}\n\n.viewMoreBtn_29_7l7B8 {\n  height: 1.066667rem;\n  line-height: 1.066667rem;\n  font-size: 0.373333rem;\n  color: #212223;\n  padding-right: 0.426667rem;\n  background: url(https://x0.ifengimg.com/ucms/2020_43/910CBF602D45604729550B72E6AAA951274865B6_w24_h26.png) no-repeat\n        right center/0.32rem auto;\n}", ""]);

// exports
exports.locals = {
	"sole": "sole_2P5tRZjo",
	"soleMd": "soleMd_1wKGmTCR",
	"soleMdImg": "soleMdImg_QbBIMpmi",
	"viewMore": "viewMore_32xGFsh1",
	"viewMoreBtn": "viewMoreBtn_29_7l7B8"
};